/**
 * survey
 */
import Sortable from 'sortablejs';

export default ((cmp, util) => {
	/**
	 * ----------------------------------------------------
	 * 一覧
	 * ----------------------------------------------------
	 */
	// 右から出るモーダルの監視とイベント
	const modalObs = util.observer($('#js-modal--white__body').get(0), function() {
		// URLとQR
      cmp.selectBox('#view-url', function(e){
        util.checkSession();
        $('#url-loading').removeClass('d-none');
        $('#url-generated').addClass('d-none');
        $.ajax({
          type: "GET",
          url: '/survey/urls/' + $(e.target).data('surveyid') + '/' + $(e.target).val() + '/-1',
          dataType: 'html'
        }).done(function (data) {
          var doc = $(data);
          $('#js-modal--white__body').html(doc);
          $('#url-loading').addClass('d-none');
          doc.ready(function() {
            // modal閉じるイベント付け直し
            cmp.modal($('#js-modal--white__body').find('js-modal--white__button').get(0), true);
          });

        }).fail(function (jqXHR, textStatus, errorThrown) {
          console.log("jqXHR: " + jqXHR.status); // HTTPステータス取得
          console.log("textStatus: " + textStatus); // タイムアウト、パースエラー
          console.log("errorThrown: " + errorThrown.message); // 例外情報
          $('#url-loading').addClass('d-none');
          $('#url-generated').removeClass('d-none');
          util.checkSession(jqXHR);
        });
      });

      cmp.selectBox('#shopset_select', function(e){
        util.checkSession();
        $('#url-loading').removeClass('d-none');
        $('#url-generated').addClass('d-none');
        $.ajax({
          type: "GET",
          url: '/survey/urls/' + $(e.target).data('surveyid') + '/-1/'+$(e.target).val(),
          dataType: 'html'
        }).done(function (data) {
          var doc = $(data);
          $('#js-modal--white__body').html(doc);
          $('#url-loading').addClass('d-none');
          doc.ready(function() {
            // modal閉じるイベント付け直し
            cmp.modal($('#js-modal--white__body').find('js-modal--white__button').get(0), true);
          });

        }).fail(function (jqXHR, textStatus, errorThrown) {
          console.log("jqXHR: " + jqXHR.status); // HTTPステータス取得
          console.log("textStatus: " + textStatus); // タイムアウト、パースエラー
          console.log("errorThrown: " + errorThrown.message); // 例外情報
          $('#url-loading').addClass('d-none');
          $('#url-generated').removeClass('d-none');
          util.checkSession(jqXHR);
        });
      });
	});

	// 作成ボタン
	cmp.modal('.btn-new-survey');

	// URLボタン
	$('.btn-view-url').each(function() { cmp.modal(this); });

	// 複製ボタン
	$('.btn-duplicate').each(function() { cmp.modal(this); });

	// 削除ボタン
	$('.btn-delete-survey').each(function() { cmp.modal(this); });

  $('.btn-archive-survey').each(function() { cmp.modal(this); });

	// モーダル監視とイベント
	const modalSObs = util.observer($('#js-modal--white__body').get(0), function() {
		// 保存ボタン
		$('#s-save-btn').click(function(){
			util.checkSession();
			cmp.messageDone('保存しています');

			var f = $(this).closest('form').get(0);
			var fd = new FormData(f);
			$.ajax({
				type: "POST",
				url: $(f).attr('action'),
				dataType: 'json',
				timeout: 20000,
				data: fd,
				processData: false,
				contentType: false
			}).done(function (data) {
				if(data.message) cmp.messageError(data.message);
				if(data.error) {
					cmp.messageCaution(data.error);
					return false;
				}
				if(data.redirect) {
					location.href = data.redirect;
					return;
				}

				location.reload();

			}).fail(function (jqXHR, textStatus, errorThrown) {
				console.log("jqXHR: " + jqXHR.status); // HTTPステータス取得
				console.log("textStatus: " + textStatus); // タイムアウト、パースエラー
				console.log("errorThrown: " + errorThrown.message); // 例外情報
				util.checkSession(jqXHR);
			});
		});
	});
	// ----------------------------------------------------------

	/**
	 * -----------------------------------------------------
	 * 編集
	 * -----------------------------------------------------
	 */

	/* 開始ページ */
	// 保存ボタン（共通利用）
	$('#save-btn,#save-preview-btn,#save-next-btn, #c-save-btn,#c-save-preview-btn,#c-save-next-btn').click(function(){
		util.checkSession();

		cmp.messageDone('保存しています');

		// 回答ページ
		if($(this).attr('id').match(/^c\-/)) {
			var fd = new FormData();
			$('.js-e001__page').each(function(p,e){
				$(this).find('.js-e001__q,.js-e001__ttl').each(function(i,e){
					fd.append('page[' +p+ '][]', $(this).data('qid'));
				});
			});
			var uri = '/survey/savecontent/' + currentView.survey_id + ($(this).attr('id') == 'c-save-preview-btn' ? '/preview' : $(this).attr('id') == 'c-save-next-btn' ? '/next' : '');
		} else {
			var fd = new FormData($(this).closest('form').get(0));
			var uri = location.pathname + ($(this).attr('id') == 'save-preview-btn' ? '/preview' : $(this).attr('id') == 'save-next-btn' ? '/next' : '');
		}

		fd.append('_xsrf', _xsrf);

		$.ajax({
			type: "POST",
			url: uri,
			dataType: 'json',
			timeout: 20000,
			data: fd,
			processData: false,
			contentType: false
		}).done(function (data) {
			if(data.error) {
				cmp.messageCaution(data.error);
				return false;
			}

			cmp.messageDone('', true); // close

			if(data.preview) window.open(data.preview, '_blank');

			if(data.next) location.href = data.next;
			return false;
		}).fail(function (jqXHR, textStatus, errorThrown) {
			console.log("jqXHR: " + jqXHR.status); // HTTPステータス取得
			console.log("textStatus: " + textStatus); // タイムアウト、パースエラー
			console.log("errorThrown: " + errorThrown.message); // 例外情報
			util.checkSession(jqXHR);
		});
	});
	// -------

	/* 設定ページ */
  cmp.selectBox('select[name="shop_set_id"]');
  // 下部ボタンは開始ページと共通
	cmp.datepicker('.datepicker');
	cmp.timepicker('.timepicker');
	// -------

	/* 回答ページ */
	// 下部ボタンは開始ページと共通
	// D&D
	const ddList = function(selector) {
		$(selector).each(function(i,e) {
			Sortable.create(e, {
				group: 'drag-' + i,
				handle: '.js-dragg__ghandle',
				animation: 300
			});
		});
	};
	ddList('.js-dragg-group');

	// 設問追加ボタン .js-e001__add-q
	const addQbutton = function() {
		$('.js-e001__add-q').off('click.addq');
		$('.js-e001__add-q').on('click.addq', function() {
			var parent = $(this).closest('.js-e001__page').find('.js-e001__list-container'); // parent
			var p = $(this).closest('.js-e001__page').data('page'); // page
			var blankQ = $(
				'<li class="js-e001__q">\n<div class="c-list-drag">\n<i class="js-dragg__ghandle">\n<svg class="svg-drag-dims">\n<use xlink:href="/assets/img/shared/sprite.symbol.svg#drag"></use>\n</svg>\n</i>\n<div class="c-list-drag__item">\n<div class="c-list-drag__item__main">\n<div class="c-list-max-width-text">\n<span class="inner">設問タイトル</span>\n</div>\n<div class="c-list-drag__item__type">\n<span class="u-visible--tab u-mr--xs"></span>\n<i>\n\n</i>\n</div>\n<div class="c-list-drag__item__num">\n<span></span>\n<span></span>\n</div>\n<div class="u-visible--pc">\n<div class="c-list-width--1">\n<button class="c-btn-tag c-btn-tag--outline c-btn-tag--outline">必須</button>\n</div>\n<div class="c-list-width--2 u-ml--xs">\n<span class="c-btn-tag c-btn-tag--outline">相関対象</span>\n</div>\n<div class="c-list-width--2 u-ml--xs">\n<span class="c-btn-tag c-btn-tag--outline">個人情報</span>\n</div>\n</div>\n<div>\n<button class="c-btn-flat c-btn--sm js-modal--white__button q-edit-btn" title="編集" data-href="/survey/question/' +currentView.survey_id+ '/0/' +p+ '">\n<i class="material-icons">create</i>\n</button>\n<!-- <button class="c-btn-flat c-btn--sm u-ml--xs u-color--primary" title="表示／非表示">\n<i class="material-icons">visibility</i>\n</button> -->\n<button class="c-btn-flat c-btn--sm u-ml--xs delete-question-btn" title="削除" data-href="m002.php">\n<i class="material-icons">delete_forever</i>\n</button>\n</div>\n</div><!-- /.c-list-drag__item__main -->\n</div>\n</div><!-- /.c-list-drag -->\n</li>'
			);
			parent.append(blankQ);
			blankQ.ready(function(){
				delQbutton();
				editQbutton();
				// 開く
				setTimeout(function(){ parent.find('.q-edit-btn:last').click() }, 340);
			});
		});
	};
	addQbutton();

	// 見出し追加ボタン .js-e001__add-ttl
	const addTbutton = function() {
		$('.js-e001__add-ttl').off('click.addt');
		$('.js-e001__add-ttl').on('click.addt', function() {
			var parent = $(this).closest('.js-e001__page').find('.js-e001__list-container');
			var p = $(this).closest('.js-e001__page').data('page');
			var blankT = $(
				'<li class="js-e001__ttl">\n<div class="c-list-drag">\n<i class="js-dragg__ghandle">\n<svg class="svg-drag-dims">\n<use xlink:href="/assets/img/shared/sprite.symbol.svg#drag"></use>\n</svg>\n</i>\n<div class="c-list-drag__item">\n<div class="c-list-drag__item__main u-bg--gray-light">\n<div class="c-list-max-width-text">\n<span class="inner">見出し</span>\n</div>\n<div>\n<button class="c-btn-flat c-btn--sm js-modal--white__button q-edit-btn" title="編集" data-href="/survey/title/' +currentView.survey_id+ '/0/' +p+ '">\n<i class="material-icons">create</i>\n</button>\n<!-- <button class="c-btn-flat c-btn--sm u-ml--xs u-color--primary" title="表示／非表示">\n<i class="material-icons">visibility</i>\n</button> -->\n<button class="c-btn-flat c-btn--sm u-ml--xs delete-question-btn" title="削除" data-href="m002.php">\n<i class="material-icons">delete_forever</i>\n</button>\n</div>\n</div><!-- /.c-list-drag__item__main -->\n</div>\n</div><!-- /.c-list-drag -->\n</li>'
			);
			parent.append(blankT);
			blankT.ready(function(){
				delQbutton();
				editQbutton();
				// 開く
				setTimeout(function(){ parent.find('.q-edit-btn:last').click() }, 340);
			});
		});
	};
	addTbutton();

	// ページ追加ボタン .js-e001__add-page-button
	const addPbutton = function() {
		$('.js-e001__add-page-button').off('click.addp');
		$('.js-e001__add-page-button').on('click.addp', function(){
			var parent = $(this).closest('.js-e001__page');
			var p = parent.index() + 1;
			var blankP = $(
				'<section class="u-mt--md u-mt-lg--lg js-e001__page">\n<div class="c-title-7">\n<h6 class="c-title-7__text"><i class="material-icons left">insert_drive_file</i><span class="js-e001__page-num">ページ3</span></h6>\n</div>\n<div class="u-txt--right u-mt--xs">\n<button class="c-btn-flat btn-small waves-effect u-waves--primary js-modal--white__button qf-edit-btn" data-href="/survey/pagefunction/' +currentView.survey_id+ '/' +p+ '"><i class="material-icons left">build</i>表示条件設定</button>\n<button class="c-btn-flat btn-small waves-effect u-waves--primary delete-page-btn" data-href="m002.php"><i class="material-icons left">delete_forever</i>ページ削除</button>\n</div>\n<div class="c-btn-container u-mt--sm">\n<button class="c-btn waves-effect u-waves--primary js-e001__add-q"><i class="material-icons left">add_circle_outline</i>設問を追加</button>\n<button class="c-btn waves-effect u-waves--primary js-e001__add-ttl"><i class="material-icons left">add</i>見出しを追加</button>\n</div>\n<div class="m-mt--md">\n<ul class="js-dragg-group js-e001__list-container">\n</ul>\n</div>\n<hr>\n<div class="c-btn-container u-mt--sm">\n<button class="c-btn waves-effect u-waves--primary js-e001__add-page-button"><i class="material-icons left">insert_drive_file</i>ページを追加</button>\n</div>\n</section><!-- /js-e001__page -->'
			);
			var page = $(blankP).insertAfter(parent);
			blankP.ready(function() {
				$('.js-e001__page').each(function(i) {
					var pagenum = i + 1;
					$(this).data('page', pagenum); // ページ番号追加
					$(this).find('.js-e001__page-num').text('ページ' + pagenum);
					var hr = $(this).find('.qf-edit-btn').data('href');
					if(!hr) return;
					$(this).find('.qf-edit-btn').data('href', hr.replace(/\d+$/, pagenum));
				});

				// Events
				addQbutton();
				addTbutton();
				addPbutton();
				delQbutton();
				delPbutton();
				editQFbutton();

				ddList('.js-dragg-group');
			});
		});
	};
	addPbutton();

	// 設問削除ボタン
	const delQbutton = function() {
		$('.delete-question-btn').off('click.delete');
		$('.delete-question-btn').on('click.delete', function(){
			if(!currentView.remove) {
				cmp.messageCaution('すでに回答のあるアンケートは項目を削除できません');
				return false;
			}

			$(this).closest('.js-e001__q,.js-e001__ttl').slideUp('normal', function(){ $(this).remove(); });
			cmp.messageCaution('削除は保存をするまで実行されません');
		});
	};
	delQbutton();

	// ページ削除ボタン .delete-page-btn
	const delPbutton = function() {
		$('.delete-page-btn').off('click.pagedel');
		$('.delete-page-btn').on('click.pagedel', function(){
			if(!currentView.remove) {
				cmp.messageCaution('すでに回答のあるアンケートはページを削除できません');
				return false;
			}

			$(this).closest('.js-e001__page').slideUp('normal', function(){
				$(this).remove();
				$('.js-e001__page-num').each(function(i,e){
					$(this).text('ページ' + (i + 1));
				});
			});
			cmp.messageCaution('削除は保存をするまで実行されません');
		});
	};
	delPbutton();

	// 表示条件設定ボタン
	const editQFbutton = function() {
		$('.qf-edit-btn').each(function() { cmp.modal(this); });
	}
	editQFbutton();

	// 編集ボタン
	const editQbutton = function() {
		$('.q-edit-btn').each(function() { cmp.modal(this); });
	}
	editQbutton();

	// 選択肢削除ボタン
	const delCbutton = function() {
		$('.delete-choice-btn').off('click.edit');
		$('.delete-choice-btn').on('click.edit', function(){
			if(!currentView.remove) {
				cmp.messageCaution('すでに回答のあるアンケートは項目を削除できません');
				return false;
			}

			$(this).closest('.li-choice').slideUp('normal', function(){ $(this).remove(); });
			cmp.messageCaution('削除は保存をするまで実行されません');
		});
	}

	// モーダル監視とイベント
	const modalQObs = util.observer($('#js-modal--white__body').get(0), function() {
		// 保存ボタン
		$('#q-save-btn').click(function(){
			util.checkSession();
			cmp.messageDone('保存しています');

			var f = $(this).closest('form').get(0);
			var fd = new FormData(f);
			$.ajax({
				type: "POST",
				url: $(f).attr('action'),
				dataType: 'json',
				timeout: 20000,
				data: fd,
				processData: false,
				contentType: false
			}).done(function (data) {
				if(data.error) {
					cmp.messageCaution(data.error);
					return false;
				}
				location.reload();

			}).fail(function (jqXHR, textStatus, errorThrown) {
				console.log("jqXHR: " + jqXHR.status); // HTTPステータス取得
				console.log("textStatus: " + textStatus); // タイムアウト、パースエラー
				console.log("errorThrown: " + errorThrown.message); // 例外情報
				util.checkSession(jqXHR);
			});
		});

		$('.delete-function-btn').click(function(){
			$(this).closest('.c-modal__body__scroller').find('input[type="checkbox"]').prop('checked', false);
			cmp.messageCaution('削除は保存をするまで実行されません');
		});

		$('input[name="is_correlation_target"]').click(function(){
			if(!$(this).prop('checked')) return true;
			for(var i = $('.js-e001__sentaku-container').children().length; i < 5; i++) {
				$('.js-e001__add-sentakushi').click();
			}
			$('.js-e001__sentaku-container').find('input[name="choice[score][]"]').each(function(i,e) {
				$(this).val(5 - i);
			});
		});

		// 選択肢追加ボタン
		$('.js-e001__add-sentakushi').on('click.addc', function(){
			var parent = $(this).closest('#cat-list').find('.js-e001__sentaku-container');
			var blankChoice = $(
				'<li class="li-choice">\n<div class="c-list-drag">\n<i class="js-dragg__ghandle">\n<svg class="svg-drag-dims">\n<use xlink:href="/assets/img/shared/sprite.symbol.svg#drag"></use>\n</svg>\n</i>\n<ul class="collapsible c-list-drag-collapsible flex-1">\n<li class="c-list-drag__item">\n<div class="c-list-drag__item__main">\n<div class="c-form__input__text flex-1">\n<div class="u-width--12">\n<input type="text" class="validate c-form__input" name="choices[text][]" placeholder="選択肢タイトルを入力してください">\n</div>\n</div>\n<div class="c-list-width--2">\n<div class="c-form__input__text">\n<div class="u-width--12">\n<input type="text" name="choices[score][]" class="validate c-form__input u-pl--none u-pr--none u-txt--center" value="0">\n</div>\n</div>\n<span class="u-ml--xs">Pt</span>\n</div>\n<!-- \n<div class="u-visible--pc">\n<div class="c-list-width--2">\n<span class="c-btn-tag c-btn-tag--outline">FA対象</span>\n</div>\n<div class="c-list-width--3 u-ml--xs">\n<span class="c-btn-tag c-btn-tag--outline">クロス集計</span>\n</div>\n</div>\n -->\n<div>\n<!-- \n<button class="c-btn-flat c-btn--sm" title="表示／非表示"><i class="material-icons">visibility_off</i></button>\n -->\n<div class="js-list-image">\n<!-- \n<div class="c-btn-flat c-btn--sm u-ml--xs c-list-drag__image-upload" title="画像アップロード">\n<label>\n<input type="file" name="file" class="js-choice-list-image">\n<i class="material-icons">add_photo_alternate</i>\n</label>\n</div>\n<div class="c-btn-flat c-btn--sm u-ml--xs c-list-drag__image-upload d-none js-modal__button" title="画像確認" data-href="/e001-2-m01.php">\n<img src="/assets/img/c-dl003_upload_thumb@2x.png" alt="">\n</div>\n</div>\n<button class="c-btn-flat c-btn--sm u-ml--xs collapsible-header" title="設定"><i class="material-icons">build</i></button>\n -->\n<button class="c-btn-flat c-btn--sm u-ml--xs delete-choice-btn" title="削除"><i class="material-icons">delete_forever</i></button>\n</div>\n</div><!-- /.c-list-drag__item__main -->\n<!-- \n<div class="collapsible-body c-list-drag__item__sub">\n<div class="d-flex align-items-center">\n<div class="u-mr--sm">\n<p class="u-mt--none u-mb--none u-visible--pc">この選択肢が選択された場合、設定されたユーザにメール通知します</p>\n<p class="u-mt--none u-mb--none u-visible--sp">メール通知設定</p>\n</div>\n<div class="flex-1">\n<input type="text">\n</div>\n</div>\n<div class="d-flex align-items-center">\n<div class="c-form__checkbox u-mr--sm">\n<label>\n<input type="checkbox" class="filled-in" />\n<span>FA（自由記入）の対象にする</span>\n</label>\n</div>\n<div class="c-form__checkbox">\n<label>\n<input type="checkbox" class="filled-in" />\n<span>クロス集計の対象にする</span>\n</label>\n</div>\n</div>\n</div>\n --><!-- /.c-list-drag__item__sub -->\n</li>\n</ul>\n</div><!-- /.c-list-drag -->\n</li>'
			);
			parent.append(blankChoice);
			blankChoice.ready(function() {
				delCbutton();
				ddList('.js-dragg-group');
			});
		});

		// 選択肢削除ボタン
		delCbutton();

		// 条件設定::アコーディオン
		if($('.collapsible').length) {
			M.Collapsible.init($('.collapsible'), { inDuration: 200 });
			ddList('.js-dragg-group');
		}

		// select2
		$('#js-modal--white__body').find('select:not(.js-e001-select)').each(function(){ cmp.selectBox(this); });

		// select2 回答方式の選択で表示・非表示
		cmp.selectBox('#js-e001-select', function() {
			var showCat = {
				status: true,
				statusKoukan: false,
				list: false,
				direction: false,
				minmaxCheck: false,
				textRule: false,
				textNum: false,
				textNumLetter: false
			};
			var selectedClass = $('#js-e001-select option:selected').attr('class').split(' ');
			for(var k in showCat) {
				$('#cat-' + k).addClass('d-none');
				if(selectedClass.includes(k)) $('#cat-' + k).removeClass('d-none');
			}
		});
		$('#js-e001-select').trigger('select2:select'); // init
	}); // ----------- モーダル監視
	// -------

	/* 終了ページ */
	// 下部ボタンは開始ページ共通
	// -------

});
